import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../api';


// Async thunk for fetching minimal coaches list
export const fetchCoachesMin = createAsyncThunk('app_options/fetchCoachesMin', async () => {
  const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/admin/coaches-list-minimal`);
  return response.data;
});

// Async thunk for fetching minimal nutrition list
export const fetchExercisesCategoriesMin = createAsyncThunk('app_options/fetchExercisesCategoriesMin', async () => {
  const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/admin/exercise-categories-list?minimal=true`);
  return response.data;
});

export const fetchNutritionList = createAsyncThunk('app_options/fetchNutritionList', async () => {
  const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/admin/nutritions-list-minimal`);
  return response.data;
});

// Async thunk for fetching minimal meals list
export const fetchUnitsList = createAsyncThunk('app_options/fetchUnitsList', async () => {
  const response = await api.get(`${process.env.REACT_APP_API_BASE_URL}/admin/units-list-minimal`);
  return response.data;
});

// Async thunk for fetching minimal meal types list
export const fetchMealTypesList = createAsyncThunk('app_options/fetchMealTypesList', async () => {
  const response = await api.get(`${process.env.REACT_APP_API_BASE_URL}/admin/meal-types-list-minimal`);
  return response.data;
});

// Async thunk for fetching minimal meal types list
export const fetchVideoCategoriesList = createAsyncThunk('app_options/fetchVideoCategoriesList', async () => {
  const response = await api.get(`${process.env.REACT_APP_API_BASE_URL}/admin/video-categories-minimal`);
  return response.data;
});

export const fetchExerciseMin = createAsyncThunk('app_options/fetchExerciseMin', async ({searchTerm='', old_exercise_id=''}) => {
  const response = await api.post(`${process.env.REACT_APP_API_BASE_URL}/customer/training/exercises-minimal`, {searchTerm:searchTerm, old_exercise_id:old_exercise_id});
  return response.data;
});

// Slice for app options
const optionsSlice = createSlice({
  name: 'app_options',
  initialState: {
    exercises_categories_min:[],
    coaches_min: [],
    ingredients_min: [],
    units_min: [],
    meal_types_min: [],
    video_categories_min: [],
    exercises_min:[]
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCoachesMin.fulfilled, (state, action) => {
        state.coaches_min = action.payload.data;
      })
      .addCase(fetchNutritionList.fulfilled, (state, action) => {
        state.nutrition_min = action.payload.data;
      })
      .addCase(fetchUnitsList.fulfilled, (state, action) => {
        state.units_min = action.payload.data;
      })
      .addCase(fetchVideoCategoriesList.fulfilled, (state, action) => {
        state.video_categories_min = action.payload.data;
      })   
      .addCase(fetchMealTypesList.fulfilled, (state, action) => {
        state.meal_types_min = action.payload.data;
      })
      .addCase(fetchExerciseMin.fulfilled, (state, action) => {
        state.exercises_min = action.payload.data;
      })
      .addCase(fetchExercisesCategoriesMin.fulfilled, (state, action) => {
        state.exercises_categories_min = action.payload.data;
      });      
  },
});

export default optionsSlice.reducer;
